<template>
  <div>
    <el-table
      :data="tableData"
      size="mini"
      style="width: 100%">
<!--      <el-table-column-->
<!--        prop="id"-->
<!--        width="50"-->
<!--        label="id">-->
<!--      </el-table-column>-->
      <el-table-column
        prop="name"
        width="100"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="department_name"
        label="职位">
      </el-table-column>
      <el-table-column label="操作" width="50">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="delTableData(scope.$index)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <el-button class="btn-icon" size="mini" type="primary" icon="el-icon-plus" circle @click="addTableData"></el-button>
    </div>
    <select-personnel ref="selectPersonnel" />
  </div>
</template>

<script>
import SelectPersonnel from "../../../../Personnel/components/selectPersonnel";
export default {
  name: "BpmnSelectUser",
  components: {SelectPersonnel},
  props:{
    user_len:{
      type:String|Number,
      default() {
        return null;
      }
    },
    tableDataProps:{
      type:Array,
      default(){
        return [];
      }
    }
  },
  model:{
    prop:"tableDataProps",
    event:"success",
  },
  data() {
    return {
      model_list:[
        {name:"请求GET",value:"get"},
        {name:"请求POST",value:"post"},
        {name:"调用类",value:"class"},
      ],
      tableData:[]
    }
  },
  mounted() {
    this.onInitTable()
  },
  watch: {
    tableDataProps:{
      deep:true,
      immediate:true,
      handler(n){
        this.onInitTable()
      }
    }
  },
  computed: {},
  methods: {
    onInitTable(){
      this.tableData=this.tableDataProps
    },
    addTableData(){
      var that=this;
      that.$refs.selectPersonnel.show({user_ids:that.tableData.map(ret=> ret.id ).join(','),user_len: that.user_len},data=>{
        if(data){
          that.tableData=[];
          data.map(ret=>{
            if(!that.tableData.find(res=>{ return res.id===ret.id })){
              that.tableData.push({
                id:ret.id,
                name:ret.name,
                department_name:ret.department_name,
              });
            }
          })

          that.$emit("success",that.tableData)
        }
      })

    },
    delTableData(index){
      this.tableData.splice(index,1);
      this.$emit("success",this.tableData)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.form-input{
  width: 100%;
}
.footer{
  margin: 5px 0;
  text-align: center;
}
.btn-icon{
  font-size: 20px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/components/BpmnSelectUser.vue